// @ts-nocheck
import { useEffect } from "react";
import ReCAPTCHA from "react-google-recaptcha";

const InvisibleReCaptcha = ({
  recaptchaRef,
  badge,
  onChange,
  hideOtherBadges = false
}: Partial<{
  // eslint-disable-next-line no-undef
  recaptchaRef?: MutableRefObject<HTMLInputElement>;
  badge?: string;
  onChange?: (token: string | null) => void;
  hideOtherBadges?: boolean;
}>) => {
  useEffect(() => {
    if (!hideOtherBadges) return;

    // Hide reCAPTCHA v3 badge when v2 Invisible is mounted to avoid duplicate badges
    const hideV3Badges = () => {
      const v3Badges = document.querySelectorAll(".grecaptcha-badge");
      const hiddenBadges: HTMLElement[] = [];

      v3Badges.forEach((badge) => {
        const badgeElement = badge as HTMLElement;
        if (!badgeElement.closest(".ehq-surveyFormContainer")) {
          if (badgeElement.style.visibility !== "hidden") {
            badgeElement.style.visibility = "hidden";
            hiddenBadges.push(badgeElement);
          }
        }
      });

      return hiddenBadges;
    };

    // Initial hide
    let hiddenBadges = hideV3Badges();

    const observer = new window.MutationObserver(() => {
      const newlyHidden = hideV3Badges();
      hiddenBadges = [...hiddenBadges, ...newlyHidden];
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });

    // Cleanup: restore visibility when component unmounts and disconnect observer
    return () => {
      observer.disconnect();
      hiddenBadges.forEach((badge) => {
        badge.style.visibility = "";
      });
    };
  }, [hideOtherBadges]);

  if (!process.env.RECAPTCHA_INVISIBLE_SITE_KEY) return null;

  return (
    <ReCAPTCHA
      size="invisible"
      ref={recaptchaRef}
      sitekey={process.env.RECAPTCHA_INVISIBLE_SITE_KEY}
      badge={badge}
      onChange={onChange}
    />
  );
};

export default InvisibleReCaptcha;
